import React from 'react'
import { IoMdHome } from 'react-icons/io'
import { IoPerson } from 'react-icons/io5'
import { SiTask, SiGmail } from 'react-icons/si'
import { Link } from 'react-router-dom'
export default function Navbar() {
  return (
    <div className='container mx-auto flex justify-center pl-6 pr-6'>
      <nav className='w-96 h-16 bg-black/80 fixed rounded-full mt-2 z-10 shadow-lg' >
        <div className="w-full h-full flex justify-between items-center gap-x-12 pl-12 pr-12">
          <Link to="/" title='home-page' className='text-[21px] text-white hover:text-[22px]'><IoMdHome /></Link>
          <Link to="/about" title='about' className='text-[21px] text-white hover:text-[22px]'><IoPerson /></Link>
          <Link to="/portfolio" title="portfolio" className='text-[21px] text-white hover:text-[22px]'><SiTask /></Link>
          <Link to="mailto:tunahantatl@gmail.com" title="Contact" className='text-[21px] text-white hover:text-[22px]'><SiGmail /></Link>

        </div>
      </nav>
    </div>

  )
}
